import React from 'react'
import Form from './Form';
import Header from './Header'

export const App = () => {
  return (
      <>
        <Header />
        <Form />
      </>
  )
}
